"use client";

import { useState } from "react";
import Image from "next/image";
import { Box, Stack } from "@chakra-ui/react";
import { PublicActionButton } from "@/shared/public-ui";

export default function ImageSwitcher() {
  const [imageUrl, setImageUrl] = useState("/images/method_next_gen.png");

  const showImage = (type: "first" | "second") => {
    setImageUrl(
      type === "first"
        ? "/images/method_next_gen.png"
        : "/images/method_traditional.png",
    );
  };

  return (
    <Box display="flex" flexDir="column" alignItems="center">
      <Image
        src={imageUrl}
        width={600}
        height={400}
        alt="Comparison of career profile methods"
        priority
        style={{
          width: "100%",
          height: "auto",
          objectFit: "cover",
          objectPosition: "center",
          borderRadius: 8,
        }}
      />

      <Stack direction="row" gap="3" mt="4" flexWrap="wrap" justify="center">
        <PublicActionButton
          size={{
            base: "sm",
            md: "md",
            lg: "lg",
          }}
          onClick={() => showImage("first")}
        >
          Next-gen
        </PublicActionButton>

        <PublicActionButton
          tone="secondary"
          size={{
            base: "sm",
            md: "md",
            lg: "lg",
          }}
          onClick={() => showImage("second")}
        >
          Old-school
        </PublicActionButton>
      </Stack>
    </Box>
  );
}
